module.exports = __webpack_public_path__ + "static/media/KTU-LT.4b3f5297.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/KTU-LT.svg
// module id = 713
// module chunks = 0